import { IPaginatedResponse, IResponse } from "../../../model";
import ServiceBase from "../../../servicebase";

export default class CotizadorService extends ServiceBase {
  graph = (data:{ idcliente?: number }) : Promise<IResponse<any>> => 
    this.GetFetch<IResponse<any>>('entity/ctacte/graph', data);

  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string, idcliente?: number }) : Promise<IPaginatedResponse<any>> => 
    this.GetFetch<IPaginatedResponse<any>>('entity/ctacte/find', data);
}
